var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.321,
    height: 17.93,
    viewBox: "0 0 20.321 17.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "press",
    transform: "translate(0 -30.127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 3.582,
    height: 1.191,
    transform: "translate(14.348 32.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 3.582,
    height: 1.191,
    transform: "translate(14.348 34.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 3.582,
    height: 1.191,
    transform: "translate(14.348 37.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 10.756,
    height: 1.191,
    transform: "translate(7.174 39.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 10.756,
    height: 1.191,
    transform: "translate(7.174 42.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 5.973,
    height: 1.191,
    transform: "translate(7.174 44.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1320",
    "data-name": "Trac\\xE9 1320",
    d: "M4.783,30.127v2.391H1.791A1.791,1.791,0,0,0,0,34.309V45.07a2.99,2.99,0,0,0,2.987,2.987H17.335a2.987,2.987,0,0,0,2.987-2.987V30.127ZM3,46.866H2.987a1.8,1.8,0,0,1-1.8-1.8V34.309a.6.6,0,1,1,1.2,0v9.565a1.791,1.791,0,0,0,1.791,1.791h.5A1.8,1.8,0,0,1,3,46.866Zm1.779-2.391h-.6a.6.6,0,0,1-.6-.6V34.309a1.782,1.782,0,0,0-.1-.6h1.3Zm14.348.6a1.8,1.8,0,0,1-1.8,1.8H5.372a2.971,2.971,0,0,0,.6-1.8V31.318H19.131Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1321",
    "data-name": "Trac\\xE9 1321",
    d: "M186.723,90.37H180.75v5.973h5.973Zm-1.191,4.783h-3.592V91.561h3.592Z",
    transform: "translate(-173.576 -57.852)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPress);
export default __webpack_public_path__ + "static/media/press.6766d80f36d7b9c271f8794d5bdf3c20.svg";
export { ForwardRef as ReactComponent };